<template>
  <div>
    <van-nav-bar
      :title="$t('app.bind_bank.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="onSubmit">
      <van-field
        v-model="realName"
        name="bankName"
        :label="$t('app.bind_bank.name')"
        :placeholder="$t('app.bind_bank.name')"
        :rules="[{ required: true, message: this.$t('app.bind_bank.name_dsc') }]"
      />
      <van-field
        v-model="bankCard"
        type="digit"
        name="bankCard"
        :label="$t('app.bind_bank.card')"
        :placeholder="$t('app.bind_bank.card')"
        :rules="[{ required: true, message: this.$t('app.bind_bank.card_dsc') }]"
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="bank"
        :label="$t('app.bind_bank.bank')"
        :placeholder="$t('app.bind_bank.bank_select')"
        @click="showPicker = true"
        :rules="[{ required: true, message: this.$t('app.bind_bank.bank_select_dsc') }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="bankList"
          @confirm="onConfirm"
          value-key="bank"
          @cancel="showPicker = false"
          :confirm-button-text="$t('app.common.confirm')"
          :cancel-button-text="$t('app.common.cancel')"
        />
      </van-popup>
      <van-field
        v-model="bankSite"
        name="bankName"
        :label="$t('app.bind_bank.bank_address')"
        :placeholder="$t('app.bind_bank.bank_address')"
        :rules="[{ required: true, message: this.$t('app.bind_bank.bank_address_dsc') }]"
      />
      <div style="margin: 16px">
        <van-button round block type="danger" size="small" native-type="submit">
          {{$t("app.common.sure")}}
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: "BindBank",
  data() {
    return {
      showPicker: false,
      realName: "",
      bankCard: "",
      bankId: "",
      bank: "",
      bankList: [],
      bankSite: "",
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    onSubmit() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "bind_bank",
            token: sessionStorage.getItem("token"),
            name: that.realName,
            bank_id: that.bankId,
            address: that.bankSite,
            card: that.bankCard,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: that.$t(res.data.msg),
              onClose: function () {
                that.$router.push({
                  path: "/member/information",
                });
              },
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
    onConfirm(value) {
      this.bank = value.bank;
      this.bankId = value.id;
      this.showPicker = false;
    },
    getBankList() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "bank_info",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
             that.bankList = res.data.data.bank;
             that.bankCard = resData.data.card;
             that.realName = resData.data.account;
             that.bankSite = resData.data.address;
             that.bank = resData.data.name;
             that.bankId = resData.data.id;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getBankList();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BindBank.vue